<script>
import {getSettingItem, setSystemSettingInfo} from "@/api/setting-api";

export default {
  name: "LauncherFormSettingView",
  data() {
    return {
      target: "LANGUAGE_EN",
      type: "VISITOR_FIELD",

      visitorConfig: [
        {"key": "name", "label": "访客姓名", "label_en": "Name"},
        {"key": "tel", "label": "手机号码", "label_en": "Mobile Number"},
        {"key": "company", "label": "所在公司", "label_en": "Company"},
        {"key": "ic", "label": "身份证号", "label_en": "ID Number"},
        {"key": "nationality", "label": "访客国籍", "label_en": "Nationality"},
        {"key": "email", "label": "访客邮箱", "label_en": "Email"},
        {"key": "tag", "label": "访客护照", "label_en": "Passport"},
        {"key": "addr", "label": "访客地址", "label_en": "Address"},
        {"key": "cardNo", "label": "访客卡号", "label_en": "Card Number"}
      ],
    }
  },
  mounted() {
    this.setupPage()
  },

  methods: {
    setupPage() {
      getSettingItem(this.target, this.type).then(({data}) => {
        console.log("getSettingItem", data)
        if (data.code === 200 && data.data.length > 0) {
          let setting = data.data[0]
          let content = JSON.parse(setting.content)
          console.log("getSettingItem", content)

          this.visitorConfig.forEach((item) => {
            let find = content.find((config) => config.key === item.key)
            if (find) {
              item.label_en = find.label_en
            }
          })
        }
      }).catch((err) => {
        console.log("getSettingItem err", err)
      })
    },

    saveSetting() {
      let content = JSON.stringify(this.visitorConfig)
      let setting = {
        target: this.target,
        type: this.type,
        content: content,
        state: "VALID"
      }
      setSystemSettingInfo(setting).then(({data}) => {
        console.log("setSystemSettingInfo", data)
        if (data.code === 200) {
          this.$message.success("保存成功")
        } else {
          this.$message.error("保存失败")
        }
      }).catch((err) => {
        console.log("setSystemSettingInfo err", err)
      })
    },


  }, // methods
}
</script>

<template>
  <div>
    <el-table :data="visitorConfig" stripe border >
      <el-table-column prop="key" label="字段名称"></el-table-column>
      <el-table-column prop="label" label="中文内容"></el-table-column>
      <el-table-column label="英文内容">
        <template slot-scope="scope">
          <el-input v-model="scope.row.label_en" ></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="p-4 text-center" style="width: 80%">
      <el-button class="w-40"  type="primary" @click="saveSetting">保存</el-button>
    </div>


  </div>
</template>

<style scoped lang="less">

</style>
